import * as $ from "jquery";
import * as ko from "knockout";
import {IMessageData} from '../../index';
import {createErrorMessage} from "../../util/misc";
import {REQUEST_MESSAGE} from "../../constants/Language";
import employee_status_codeHtml from './employee-status-code.html?raw';

export let template = employee_status_codeHtml;

interface IParams {
    code: number
}

interface ICode {
    code: string
    level: string
    name: string
    parentCode: any
    presentationName: string
    shortName: string
    validFrom: string
    validFromInRequestedRange: string
    validToInRequestedRange: any
}

export class viewModel {
    private messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    private isReady: KnockoutObservable<boolean | null> = ko.observable(null);
    private displayNameA: string | null = null;
    private displayNameB: string | null = null;
    private req!: JQuery.jqXHR<any>;

    constructor(private params: IParams) {
        if (String(params.code).length == 7) {
            this.init();
        }
    }

    private init() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE, type: 'info'});
        this.req = jQuery.ajax({
            url: `https://data.ssb.no/api/klass/v1/classifications/145/codes.json?from=2010-01-01&selectCodes=${this.params.code}`,
            success: (data: { codes: ICode[] }) => {
                if (data.codes.length) {
                    const d = data.codes[0];
                    if (!d) {
                        return;
                    }
                    const regex = /(.*)\s\(\s?(.*)\)/gmi;
                    this.displayNameA = d.name.replace(regex, '$1');
                    const res = regex.exec(d.name);
                    if (res && res[2]) {
                        this.displayNameB = d.name.replace(regex, '$2');
                    }
                    this.messageData(null);
                    this.isReady(true);
                } else {
                    this.messageData({message: 'data not available', type: 'warning'});
                }
            },
            error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
                this.messageData(createErrorMessage(textStatus));
            }
        });
    }

    dispose() {
        if (this.req) {
            this.req.abort();
        }
    }
}
